(function() {
  'use strict';

  // i18n() is a no-op marker so the extraction script can find these keys.
  // The actual translation happens via `| translate` in kz-header-menu.html.
  function i18n(key) { return key; }

  var mainMenu = [
    {
      title: i18n('Dashboard'),
      extendBy: 'dashboard.index',
      links: [
        {
          title: i18n('Dashboard'),
          route: ['/dashboard'],
          placeholder: true
        },
        {
          title: i18n('Manage dashboard templates'),
          route: ['/dashboard-templates'],
          permission: 'dashboardTemplates.view'
        },
        {
          title: i18n('Manage summary templates'),
          route: ['/profile-templates'],
          permission: 'profileTemplates.view'
        }
      ]
    },
    {
      title: i18n('Timeline'),
      extendBy: 'epf.events.index',
      links: [
        {
          title: i18n('Timeline'),
          route: ['/events/list'],
          permission: 'events.view.own',
          placeholder: true
        },
        {
          title: i18n('Manage categories'),
          route: ['/events/manage'],
          permission: 'organisation.manage-timelines'
        }
      ]
    },
    {
      title: i18n('Files'),
      route: ['/files'],
      permission: 'events.view.own'
    },
    {
      title: i18n('Content'),
      links: [
        {
          title: i18n('FAQs'),
          route: ['/faqs'],
          permission: 'faqs.view'
        },
        {
          title: i18n('Event types'),
          route: ['/event-types'],
          permission: 'eventTypes.view'
        },
        {
          title: i18n('Blueprints'),
          route: ['/blueprints'],
          permission: 'blueprints.view'
        },
        {
          title: i18n('Blueprint Maps'),
          route: ['/blueprint-maps'],
          permission: 'blueprints.view',
          requireFeature: 'blueprint-maps'
        },
        {
          title: i18n('Announcements'),
          route: ['/announcements'],
          permission: 'announcements.view'
        },
        {
          title: i18n('Email templates'),
          permission: 'emailTemplates.view',
          route: ['/emails']
        },
        {
          title: i18n('Bulk actions'),
          route: ['/bulk-actions'],
          permission: [
            'BulkActionsService',
            function(BulkActionsService) {
              return BulkActionsService.getAvailableBulkActions()
                .then(function(availableBulkActions) {
                  return !_.isEmpty(availableBulkActions);
                });
            }
          ]
        }
      ]
    },
    {
      title: i18n('Goals'),
      extendBy: 'epf.goals.index',
      links: [
        {
          title: i18n('Goals'),
          route: ['/goals/list'],
          permission: 'goals.work.own',
          placeholder: true
        },
        {
          title: i18n('Manage categories'),
          route: ['/goals/manage'],
          permission: 'organisation.manage-categories'
        }
      ]
    },
    {
      title: i18n('Reports'),
      links: [
        {
          title: i18n('Reports'),
          route: ['/report_templates'],
          permission: 'reports.view',
          excludeFeature: 'reporting'
        },
        {
          title: i18n('Manage legacy report templates'),
          route: ['/report_templates'],
          permission: 'reports.edit',
          requireFeature: 'reporting'
        },
        {
          title: i18n('Manage report templates'),
          route: ['/report-management'],
          permission: 'reports.edit',
          requireFeature: 'reporting'
        },
        {
          title: i18n('Reports'),
          route: ['/reports'],
          permission: 'reports.view',
          requireFeature: 'reporting'
        }
      ]
    },
    {
      title: i18n('User management'),
      links: [
        {
          title: i18n('Users'),
          route: ['/users'],
          permission: 'users.view'
        },
        {
          title: i18n('All events'),
          route: ['/allevents'],
          permission: 'events.view'
        },
        {
          title: i18n('Pending sections'),
          route: ['/admin/pending-sections'],
          permission: [
            'AdminService', 'SecurityService',
            function(AdminService, Security) {
              // Implementing or below - lets check the permission first
              // if no permission try the reviewable sections
              return Security.hasPermission('events.reviewPending')
                .catch(function() {
                  return AdminService.getReviewableSections()
                    .then(function(sections) {
                      return sections.length > 0;
                    });
                });
            }
          ]
        },
        {
          title: i18n('User fields'),
          route: ['/user-fields'],
          permission: 'userFields.view'
        },
        {
          title: i18n('Relations'),
          route: ['/relations'],
          permission: 'relations.view'
        },
        {
          title: i18n('Roles'),
          route: ['/roles'],
          permission: 'roles.view'
        },
        {
          title: i18n('Organisations'),
          route: ['/organisations'],
          permission: ['SecurityService', function(Security) {
            return Security.hasRole('system:superadmin');
          }]
        }
      ]
    }
      ],
      menu = {
        main: mainMenu
      };

  angular.module('epf.layout')
    .constant('HEADER_MENU', menu);
})();
